const paintings3 = [
  {
    id: '3_01',
    name: 'Return from the Falcon Hunt',
    imageSrc: 'level3/3_01.jpg',
    cutSrc: 'level3/cut/3_01.jpg',
    author: 'BERCHEM, Nicolaes',
    year: '1650',
  },
  {
    id: '3_02',
    name: 'Rocky Landscape with Antique Ruins',
    imageSrc: 'level3/3_02.jpg',
    cutSrc: 'level3/cut/3_02.jpg',
    author: 'BERCHEM, Nicolaes',
    year: '1657',
  },
  {
    id: '3_03',
    name: 'The Banks of the Manzanares River',
    imageSrc: 'level3/3_03.jpg',
    cutSrc: 'level3/cut/3_03.jpg',
    author: 'BERUETE, Aureliano',
    year: '1878',
  },
  {
    id: '3_04',
    name: 'The Augustan Bridge',
    imageSrc: 'level3/3_04.jpg',
    cutSrc: 'level3/cut/3_04.jpg',
    author: 'BIDAULD, Jean-Joseph-Xavier',
    year: '1790',
  },
  {
    id: '3_05',
    name: 'Landscape with Sarcophagus',
    imageSrc: 'level3/3_05.jpg',
    cutSrc: 'level3/cut/3_05.jpg',
    author: 'BLANCHET, Thomas',
    year: '1650-1652',
  },
  {
    id: '3_06',
    name: "Building the Devil's Bridge",
    imageSrc: 'level3/3_06.jpg',
    cutSrc: 'level3/cut/3_06.jpg',
    author: 'BLECHEN, Karl',
    year: '1833',
  },
  {
    id: '3_07',
    name: 'Stag Hunting in the Dunes',
    imageSrc: 'level3/3_07.jpg',
    cutSrc: 'level3/cut/3_07.jpg',
    author: 'BLEKER, Gerrit Claesz',
    year: '1625-1629',
  },
  {
    id: '3_08',
    name: 'Landscape with the Prophet Elijah in the Desert',
    imageSrc: 'level3/3_08.jpg',
    cutSrc: 'level3/cut/3_08.jpg',
    author: 'BLOEMAERT, Abraham',
    year: '1610',
  },
  {
    id: '3_09',
    name: 'River Landscape with a Town and Fortified Tower',
    imageSrc: 'level3/3_09.jpg',
    cutSrc: 'level3/cut/3_09.jpg',
    author: 'GOYEN, Jan van',
    year: '1633',
  },
  {
    id: '3_10',
    name: 'The Champion Single Sculls (Max Schmitt in a Single Scull)',
    imageSrc: 'level3/3_10.jpg',
    cutSrc: 'level3/cut/3_10.jpg',
    author: 'EAKINS, Thomas',
    year: '1871',
  },
  {
    id: '3_11',
    name: 'A Frigate, Calm Seas',
    imageSrc: 'level3/3_11.jpg',
    cutSrc: 'level3/cut/3_11.jpg',
    author: 'ECKARDT, Christian Frederik Emil',
    year: '1867',
  },
  {
    id: '3_12',
    name: 'A Brig under Sail in Fair Weather',
    imageSrc: 'level3/3_12.jpg',
    cutSrc: 'level3/cut/3_12.jpg',
    author: 'ECKERSBERG, Christoffer Wilhelm',
    year: '1844-1845',
  },
  {
    id: '3_13',
    name: 'The Cloisters, San Lorenzo fuori le mura',
    imageSrc: 'level3/3_13.jpg',
    cutSrc: 'level3/cut/3_13.jpg',
    author: 'ECKERSBERG, Christoffer Wilhelm',
    year: '1824',
  },
  {
    id: '3_14',
    name: 'View of Amsterdam',
    imageSrc: 'level3/3_14.jpg',
    cutSrc: 'level3/cut/3_14.jpg',
    author: 'EKELS, Jan the Elder',
    year: '1750-1780',
  },
  {
    id: '3_15',
    name: 'View of the Zuidsingel, Amersfoort',
    imageSrc: 'level3/3_15.jpg',
    cutSrc: 'level3/cut/3_15.jpg',
    author: 'EKELS, Jan the Elder',
    year: '1760-1780',
  },
  {
    id: '3_16',
    name: 'Seascape',
    imageSrc: 'level3/3_16.jpg',
    cutSrc: 'level3/cut/3_16.jpg',
    author: 'EYCK, Gaspard van',
    year: '1650',
  },
  {
    id: '3_17',
    name: 'Southern Pastoral',
    imageSrc: 'level3/3_17.jpg',
    cutSrc: 'level3/cut/3_17.jpg',
    author: 'BERCHEM, Nicolaes',
    year: '1658',
  },
  {
    id: '3_18',
    name: 'Winter Landscape',
    imageSrc: 'level3/3_18.jpg',
    cutSrc: 'level3/cut/3_18.jpg',
    author: 'BERGHE, Christoffel van den',
    year: '1615-1620',
  },
  {
    id: '3_19',
    name: 'The Silver Seascape',
    imageSrc: 'level3/3_19.jpg',
    cutSrc: 'level3/cut/3_19.jpg',
    author: 'BEYEREN, Abraham van',
    year: '1640-1650',
  },
  {
    id: '3_20',
    name: 'View of the Isle of Sora',
    imageSrc: 'level3/3_20.jpg',
    cutSrc: 'level3/cut/3_20.jpg',
    author: 'BIDAULD, Jean-Joseph-Xavier',
    year: '1793',
  },
  {
    id: '3_21',
    name: 'Cavalry Battle Scene',
    imageSrc: 'level3/3_21.jpg',
    cutSrc: 'level3/cut/3_21.jpg',
    author: 'BLEKER, Gerrit Claesz',
    year: '1656',
  },
  {
    id: '3_22',
    name: 'Landscape with the Parable of the Tares among the Wheat',
    imageSrc: 'level3/3_22.jpg',
    cutSrc: 'level3/cut/3_22.jpg',
    author: 'BLOEMAERT, Abraham',
    year: '1624',
  },
  {
    id: '3_23',
    name: 'A Scene in the Roman Campagna',
    imageSrc: 'level3/3_23.jpg',
    cutSrc: 'level3/cut/3_23.jpg',
    author: 'BLOEMEN, Jan Frans van',
    year: '1736',
  },
  {
    id: '3_24',
    name: 'Naples, a View of Mergellina',
    imageSrc: 'level3/3_24.jpg',
    cutSrc: 'level3/cut/3_24.jpg',
    author: 'BLOEMEN, Jan Frans van',
    year: '1777',
  },
  {
    id: '3_25',
    name: 'River Landscape',
    imageSrc: 'level3/3_25.jpg',
    cutSrc: 'level3/cut/3_25.jpg',
    author: 'GAINSBOROUGH, Thomas',
    year: '1768-1770',
  },
  {
    id: '3_26',
    name: "The Seine in Paris between the Pont d'Iéna and Pont de Grenelle",
    imageSrc: 'level3/3_26.jpg',
    cutSrc: 'level3/cut/3_26.jpg',
    author: 'GAUGUIN, Paul',
    year: '1875',
  },
  {
    id: '3_27',
    name: "A Corroboree in Van Diemen's Land",
    imageSrc: 'level3/3_27.jpg',
    cutSrc: 'level3/cut/3_27.jpg',
    author: 'GLOVER, John',
    year: '1840',
  },
  {
    id: '3_28',
    name: 'Beach at Scheveningen in Stormy Weather',
    imageSrc: 'level3/3_28.jpg',
    cutSrc: 'level3/cut/3_28.jpg',
    author: 'GOGH, Vincent van',
    year: '1882',
  },
  {
    id: '3_29',
    name: 'Farmhouses among Trees',
    imageSrc: 'level3/3_29.jpg',
    cutSrc: 'level3/cut/3_29.jpg',
    author: 'GOGH, Vincent van',
    year: '1883',
  },
  {
    id: '3_30',
    name: 'Two Peasant Women in the Peat Field',
    imageSrc: 'level3/3_30.jpg',
    cutSrc: 'level3/cut/3_30.jpg',
    author: 'GOGH, Vincent van',
    year: '1883',
  },
  {
    id: '3_31',
    name: 'The Parsonage Garden at Nuenen in Spring',
    imageSrc: 'level3/3_31.jpg',
    cutSrc: 'level3/cut/3_31.jpg',
    author: 'GOGH, Vincent van',
    year: '1884',
  },
  {
    id: '3_32',
    name: 'In the Jardin du Luxembourg',
    imageSrc: 'level3/3_32.jpg',
    cutSrc: 'level3/cut/3_32.jpg',
    author: 'GOGH, Vincent van',
    year: '1886',
  },
  {
    id: '3_33',
    name: 'View of Paris from Montmartre',
    imageSrc: 'level3/3_33.jpg',
    cutSrc: 'level3/cut/3_33.jpg',
    author: 'GOGH, Vincent van',
    year: '1886',
  },
  {
    id: '3_34',
    name: 'Olive Picking',
    imageSrc: 'level3/3_34.jpg',
    cutSrc: 'level3/cut/3_34.jpg',
    author: 'GOGH, Vincent van',
    year: '1889',
  },
  {
    id: '3_35',
    name: 'Landscape with Carriage and Train in the Background',
    imageSrc: 'level3/3_35.jpg',
    cutSrc: 'level3/cut/3_35.jpg',
    author: 'GOGH, Vincent van',
    year: '1890',
  },
  {
    id: '3_36',
    name: 'Wheat Field under Clouded Sky',
    imageSrc: 'level3/3_36.jpg',
    cutSrc: 'level3/cut/3_36.jpg',
    author: 'GOGH, Vincent van',
    year: '1890',
  },
  {
    id: '3_37',
    name: 'Wheat Field with Crows',
    imageSrc: 'level3/3_37.jpg',
    cutSrc: 'level3/cut/3_37.jpg',
    author: 'GOGH, Vincent van',
    year: '1890',
  },
  {
    id: '3_38',
    name: 'The Meadow of San Isidro on his Feast Day',
    imageSrc: 'level3/3_38.jpg',
    cutSrc: 'level3/cut/3_38.jpg',
    author: 'GOYA Y LUCIENTES, Francisco de',
    year: '1788',
  },
  {
    id: '3_39',
    name: 'Dune Landscape',
    imageSrc: 'level3/3_39.jpg',
    cutSrc: 'level3/cut/3_39.jpg',
    author: 'GOYEN, Jan van',
    year: '1631',
  },
  {
    id: '3_40',
    name: 'Haymaking',
    imageSrc: 'level3/3_40.jpg',
    cutSrc: 'level3/cut/3_40.jpg',
    author: 'GOYEN, Jan van',
    year: '1630',
  },
];

export default paintings3;
